var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBajasTemperaturas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6C6C6C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "57,168.9 44.7,168.9 41.8,157.1 50.8,141.2 35.1,141.2 29,132.1 35.1,123 62.6,123 74.8,98.7  77.5,100.1 64.5,126.2 36.7,126.2 32.7,132.1 36.7,138.2 56.2,138.2 45.1,157.5 47.2,165.9 55.1,165.9 66.2,146.5 74.6,163.3  82.6,163.3 84.6,157.4 73.2,133.4 88.6,105 91.4,106.4 76.6,133.4 87.9,157.2 84.8,166.4 72.7,166.4 66,153  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "133.3,168.8 121.6,165.3 112.6,149.4 104.5,162.9 93.6,163.6 88.9,153.7 103,130 88.3,107.1  90.9,105.4 106.6,129.9 92.4,153.8 95.5,160.3 102.7,160 112.6,143.2 123.6,162.7 131.8,165.2 135.9,158.4 124.9,138.9  143.7,140.3 147.8,133.4 143.8,128.8 117.2,126.2 100.8,98.4 103.5,96.8 119.1,123.3 145.3,125.8 151.6,133.1 145.4,143.5  130.5,142.5 139.5,158.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "105.8,81.3 103,79.8 116,53.8 143.8,53.8 147.8,47.9 143.8,41.8 124.4,41.8 135.4,22.5 133.4,14.1  125.4,14.1 114.4,33.5 106,16.7 98,16.7 96,22.6 107.4,46.6 91.9,75 89.2,73.6 103.9,46.6 92.7,22.8 95.7,13.6 107.9,13.6  114.5,27 123.6,11.1 135.8,11.1 138.8,22.9 129.7,38.8 145.5,38.8 151.6,47.9 145.5,57 117.9,57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "77.2,83.2 61.5,56.7 35.3,54.2 29,46.9 35.2,36.5 50.1,37.5 41.1,21.6 47.3,11.2 59,14.7 68,30.6  76.1,17.1 86.9,16.4 91.7,26.3 77.5,50 92.2,72.9 89.6,74.6 73.9,50.1 88.2,26.2 85.1,19.7 77.8,20 67.9,36.8 56.9,17.3 48.7,14.8  44.7,21.6 55.6,41.1 36.9,39.7 32.8,46.6 36.9,51.2 63.3,53.8 79.8,81.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.4,121.2 14.9,110.4 23.8,98.4 5.5,97.5 0,86.7 9.2,78.7 27.5,79.5 20.3,65.5 25.6,56 36.5,57.2  48.9,81.7 76.2,81.5 76.2,84.6 47.1,84.9 34.5,60.1 27.3,59.3 23.8,65.5 32.6,82.9 10.3,81.8 3.8,87.4 7.5,94.5 29.7,95.6  18.6,110.7 22.2,117.8 28.4,116.9 44.6,95.8 76.9,96.7 76.8,99.8 46.1,98.9 30.1,119.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "154.4,125.3 143.5,124 131.1,99.5 103.8,99.7 103.8,96.7 132.9,96.4 145.5,121.2 152.7,122  156.2,115.7 147.4,98.4 169.7,99.5 176.2,93.8 172.5,86.8 150.3,85.7 161.4,70.6 157.8,63.4 151.6,64.4 135.4,85.4 103.2,84.6  103.2,81.4 133.9,82.3 149.9,61.5 159.6,60 165.1,70.9 156.2,82.9 174.5,83.7 180,94.6 170.8,102.6 152.5,101.7 159.7,115.8  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBajasTemperaturas);
export default __webpack_public_path__ + "static/media/bajas-temperaturas.d3750316ff901e0d6d798f20d2de34de.svg";
export { ForwardRef as ReactComponent };